export default __webpack_public_path__ + "static/media/marker-place-selected.bfa18bec.png";